import { styled } from '@creditas/stylitas';

export const ConfimationContainer = styled.div`
  margin: 2rem;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
